var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1811 59.0379L5.70206 58.9824L56.1733 1.00444C58.8826 1.01529 61.0743 3.21549 61.0883 5.90357L61.0797 54.1338C61.0797 54.1341 61.0797 54.1343 61.0797 54.1345C61.0721 56.8407 58.872 59.027 56.1811 59.0379ZM5.69328 0.948841L56.1723 1.00443L5.70106 58.9824C2.99197 58.9715 0.800504 56.7718 0.786071 54.0841C0.786069 54.0838 0.78607 54.0835 0.786068 54.0832L0.794628 5.85295C0.79463 5.85269 0.794628 5.85243 0.79463 5.85217C0.802338 3.1464 3.00177 0.960412 5.69215 0.948846C5.69253 0.948843 5.6929 0.948844 5.69328 0.948841Z",
    stroke: "#C5C5C5",
    strokeWidth: 0.740873
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4007 52.1847L9.02281 52.1533C7.76749 52.154 6.76537 51.1562 6.76319 49.9023L6.75693 10.0398C6.75475 8.78593 7.75269 7.7861 9.008 7.78533L53.3859 7.81677C54.6412 7.816 55.6433 8.81389 55.6455 10.0677L55.6517 49.9303C55.6539 51.1841 54.656 52.1839 53.4007 52.1847Z",
    fill: "#E4DAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9943 23.8088C25.2833 22.7201 25.4434 20.7929 24.352 19.5042C23.2606 18.2155 21.3309 18.0533 20.0419 19.142C18.7529 20.2307 18.5928 22.158 19.6842 23.4467C20.7756 24.7353 22.7053 24.8975 23.9943 23.8088Z",
    fill: "#AD91F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.007 37.0365L15.9932 37.0178L19.9961 32.5061L21.9975 30.2502L23.9989 27.9943L26.001 30.2548L28.003 32.5154L32.007 37.0365Z",
    fill: "#FACE8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8604 28.9597L24.4402 28.7144L24.1997 28.9324L23.6418 28.7609L23.1441 28.9577L23.5731 28.4742L23.7876 28.2324L24.0021 27.9906L24.2167 28.2329L24.4313 28.4752L24.8604 28.9597Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4926 37.0621L22.1558 37.0349L27.9891 30.4599L30.9058 27.1724L33.8224 23.8849L36.74 27.1792L39.6575 30.4735L45.4926 37.0621Z",
    fill: "#FCDEB1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0769 25.2987L34.4646 24.9412L34.1141 25.2588L33.301 25.009L32.5758 25.2958L33.201 24.5911L33.5136 24.2388L33.8262 23.8864L34.1389 24.2395L34.4516 24.5926L35.0769 25.2987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon4);
export default __webpack_public_path__ + "static/media/productIcon4.defaa6664bba843ca9110599957195ad.svg";
export { ForwardRef as ReactComponent };